import { Fragment as _Fragment, jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import StickyBox from "react-sticky-box";
export function SharedTableHeader(props) {
    const { visibleColumns, adjustedColumns, sortOption, onSortChange, stickyOffset, headerClassName, gridTemplateColumns, } = props;
    return (_jsx(StickyBox, { offsetTop: stickyOffset, style: { zIndex: 40, marginTop: -1 }, children: _jsx("div", { className: headerClassName, style: { display: "grid", gridTemplateColumns }, children: visibleColumns.map((colId) => {
                const col = adjustedColumns[colId];
                if (!col)
                    return null;
                return (_jsx("div", { className: col.className, children: col.renderHeader ? (col.renderHeader({
                        sortOption,
                        onSortChange,
                    })) : (_jsxs(_Fragment, { children: ["Header col ", colId] })) }, colId));
            }) }) }));
}
